export default {
  language: 'CN',
  search: 'Search',
  expand: 'More',
  collapse: 'Less'
}; 